// extracted by mini-css-extract-plugin
export default {"float":"TenderPortalFloat_float__d-niI","aboveCookieBar":"TenderPortalFloat_aboveCookieBar__6sWTE"};